import { Component, OnInit } from '@angular/core';
import { StoreService } from '../core';
//import { ErrorService } from '../services';
//import { eErrorMode } from '../models';
//import { DialogService } from '../dialog';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.css']
})

export class ErrorComponent implements OnInit {

  errorMessage1: string = '';
  errorMessage2: string = '';
  errorUrl: string = '';

  constructor(
    private store: StoreService
  ) { }

  ngOnInit(): void {
    this.store.showSplash(false);
    const r: string = this.store.getStocked('ERX', true);
    if (r && r !== '') {
      const error: any = JSON.parse(r);
      this.errorUrl = error.url;
      this.errorMessage1 = error.message ? error.message : '';
      this.errorMessage2 = error.error && error.error.message ? error.error.message : '';
    }
    //const modo: eErrorMode = this.errorservice.getErrorMode();
    //switch (modo) {
    //  case eErrorMode.QUEOVAL:
    //    this.errorMessage = this.errorservice.getQueovalError();
    //    break;
    //  case eErrorMode.GENERIC:
    //    this.errorMessage = 'Vérifier la console du navigateur pour voir les détails de l\'erreur';
    //}
    //this.errorUrl = this.errorservice.getRequestUrl();
  }
}
